module.exports = "<div class=\"h-container\">\n  <app-menu [menuOpen]=\"menu_open\" [menuClose]=\"menu_close\" ></app-menu>\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main